import { useImmerAtom } from 'jotai-immer';
import {
    procErrorsTableViewAtom,
    procErrorsTableFiltersAtom,
    procErrorsTableStatsAtom,
    procErrorsDataAtom,
    ProcessingErrorItem,
} from './processingerrors_atoms';
import { useTableData } from '../../../../core/table/hooks/useTableData';

export const useProcessingErrorsData = (): { items: ProcessingErrorItem[] } => {
    const [view] = useImmerAtom(procErrorsTableViewAtom);
    const [filters] = useImmerAtom(procErrorsTableFiltersAtom);
    const [stats, setStats] = useImmerAtom(procErrorsTableStatsAtom);
    const [data] = useImmerAtom(procErrorsDataAtom);

    const { items } = useTableData<ProcessingErrorItem>({
        view,
        filters,
        stats,
        data,
        setStats,
    });

    return { items };
};
